import HeaderSuccessStory from './HeaderSuccessStory'

export default HeaderSuccessStory